import { RadioGroup } from 'devextreme-react';
import TextArea from 'devextreme-react/text-area';
import React, { createRef, Fragment, PropsWithChildren } from 'react';
import './radio-button-list.scss';

type Props<T> = {
    data : T[],
    displayExpr: string,
    valueExpr : string,
    otherKeyValue? : number | string,
    onOtherValueChanged?: (otherValue : string) => void,
    otherValue? : string,
    selectedItem : T,
    handleRadioChecked: (itemKey : any) => void,
}


export const RadioButtonList = <T,>({data, displayExpr, valueExpr, otherKeyValue, onOtherValueChanged = () => {}, otherValue, selectedItem, handleRadioChecked = () => {}}: PropsWithChildren<Props<T>>) => {

    const otherTextRef = createRef<TextArea>()

    const handleKeyUp = ()  => {
        let textBox = otherTextRef?.current?.instance
        const text = textBox?.option('text')
        text && onOtherValueChanged(text)
    }

    const renderRadioItem = (itemData : any) => {
        return (
            <Fragment >
                    {itemData && itemData[valueExpr] == otherKeyValue ?
                        <div className={'radio-button-text-area'}>
                            <TextArea 
                                ref={otherTextRef} 
                                placeholder={'Other'} 
                                value={otherValue} 
                                onKeyUp={ () => handleKeyUp()} 
                            />
                        </div>   
                    :
                        <div className={'radio-button-item'}>{itemData[displayExpr]}</div>
                    }
            </Fragment>
        )
    }

    if(!displayExpr && !valueExpr) {
        throw 'displayExpr and valueExpr are required'
    }

    return (
        <Fragment >
            {data && data.length > 0 &&
                <RadioGroup 
                    value={selectedItem && (selectedItem as any)[valueExpr]} 
                    dataSource={data} 
                    itemRender={renderRadioItem} 
                    onValueChanged={e => handleRadioChecked(e.value)}
                    valueExpr={valueExpr}
                    displayExpr={displayExpr}
                />
            }
        </Fragment>
    )
}